import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import { getCompanyCollection } from '../../../firebase'

const restar = async (almacen, producto, zonas, cantidad) =>{
    const fecha = new Date();
    
    if (producto === '' || !zonas || cantidad <= 0) {
        alert('Llene todos los campos' ) 
        return null
    }
    try {
        const batch = firebase.firestore().batch()
        const apps = await getCompanyCollection('Aplicaciones')
        const inventory = await getCompanyCollection('Inventario')
        const product = (await inventory
            .where('nombre', '==', producto)
            .where('ubicacion', '==', almacen)
            .get()).docs[0]
        for (let i = 0; i < zonas.length; i++){
            const result = parseFloat(cantidad)/parseFloat(zonas.length)
            const datos = {
                producto: producto, 
                zona: zonas[i], 
                cantidad: result.toFixed(3), 
                fecha: fecha, 
                unidades: product.data().unidades
            }
            batch.set(apps.doc(), datos)
        }
        batch.update(inventory.doc(product.id), { enInventario: product.data().enInventario - cantidad })
        batch.commit()
    }
    catch (e) {
        console.log(e)
        alert('Ocurrió un error!')
    }
}

const mover = async (uOrigen, uDestino, producto, cantidad, unidades) =>{
    let movimiento= {
        almacenOrigen: uOrigen,
        almacenDestino: uDestino,
        producto: producto,
        unidades: unidades,
        cantidad: cantidad.toFixed(2),
        fecha: firebase.firestore.FieldValue.serverTimestamp(),
    }

    try {
        const movements = await getCompanyCollection('MovimientosInventario')
        const db = await getCompanyCollection('Inventario')
        const batch = firebase.firestore().batch()

        const prodOrigen = (await db
            .where('ubicacion', '==', movimiento.almacenOrigen)
            .where('nombre', '==', movimiento.producto)
            .get()).docs[0]
        const prodDestino = (await db
            .where('ubicacion', '==', movimiento.almacenDestino)
            .where('nombre', '==', movimiento.producto)
            .get()).docs[0]
        if (prodOrigen.data().enInventario > 0) {
            batch.set(movements.doc(), movimiento)
            batch.update(db.doc(prodOrigen.id), { enInventario: (prodOrigen.data().enInventario - movimiento.cantidad) })
            if (prodDestino !== undefined) {
                batch.update(db.doc(prodDestino.id), { enInventario: (parseFloat(prodDestino.data().enInventario) + parseFloat(movimiento.cantidad)) })
            }
            else {
                batch.set(db.doc(), {
                    enInventario: parseFloat(movimiento.cantidad),
                    nombre: prodOrigen.data().nombre,
                    ubicacion: movimiento.almacenDestino,
                    unidades: prodOrigen.data().unidades,
                })
            }
        }
        await batch.commit()
    }
    catch (e) {
        console.log(e)
        alert("Error: "+e)
    }
}

const InventarioTools={
    restar,
    mover,
}

export default InventarioTools
